module.exports = __webpack_public_path__ + "img/[跳跳].3bea412e.svg";